import Badge from "../../../Components/Badge";
import EditIcon from "../../../Assets/Icons/outline/edit.svg";
import TrashIcon from "../../../Assets/Icons/outline/trash.svg";

const MemberTable = ({ data, from, handleShow }) => {
  return (
    <table className="w-full text-left">
      <thead className="border-t border-b border-black">
        <tr>
          <th scope="col" className="px-6 py-1">
            <div className="border-e border-black py-1">No</div>
          </th>
          <th scope="col" className="px-6 py-1">
            <div className="border-e border-black py-1">Name</div>
          </th>
          <th scope="col" className="px-6 py-1">
            <div className="border-e border-black py-1">Group</div>
          </th>
          <th scope="col" className="px-6 py-1">
            <div className="border-e border-black py-1">Role</div>
          </th>
          <th scope="col" className="px-6 py-1">
            <div className="border-e border-black py-1">Phone Number</div>
          </th>
          <th scope="col" className="px-6 py-1">
            <div className="border-e border-black py-1">Status</div>
          </th>
          <th scope="col" className="px-6 py-1">
            <div className="py-1">Action</div>
          </th>
        </tr>
      </thead>
      <tbody className="font-light">
        {data?.map((item, index) => (
          <tr key={index}>
            <td className="px-6 py-4 w-[100px]">{from++}</td>
            <td className="px-6 py-4">
              <div className="font-semibold">{item?.name}</div>
              <div>{item?.email}</div>
            </td>
            <td className="px-6 py-4 w-[250px]">{item?.group?.name}</td>
            <td className="px-6 py-4 w-[250px]">{item?.roles?.[0]?.name}</td>
            <td
              className="px-6 py-4 w-[220px]"
              role="button"
              onClick={() =>
                window.open("https://wa.me/" + item?.phone_number, "_blank")
              }
            >
              {item?.phone_number}
            </td>
            <td className="px-6 py-4 w-[230px]">
              <Badge
                className={`${
                  item?.status === 1 ? "bg-green-900" : "bg-red-900"
                } text-white w-[150px]`}
              >
                {item?.status === 1 ? "Active" : "Not Active"}
              </Badge>
            </td>
            <td className="px-6 py-4 w-[150px]">
              <div className="flex items-center">
                <div className="me-5">
                  <button
                    className="button"
                    onClick={() => handleShow(null, "update", item)}
                  >
                    <img src={EditIcon} alt="" className="w-[25px] h-[25px]" />
                  </button>
                </div>
                <div className="me-5">
                  <button
                    className="button"
                    onClick={() => handleShow(null, "delete", item)}
                  >
                    <img src={TrashIcon} alt="" className="w-[25px] h-[25px]" />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MemberTable;
